export const GET_USER_CREDIT_INFO = "GET_USER_CREDIT_INFO";
export const GET_USER_CREDIT_INFO_SUCCESS = "GET_USER_CREDIT_INFO_SUCCESS";

export const SET_MY_CREDITS_LOADING = "SET_MY_CREDITS_LOADING";

export const GET_USER_PCT_UNLOCK_HISTORY = "GET_USER_PCT_UNLOCK_HISTORY";
export const GET_USER_PCT_UNLOCK_HISTORY_SUCCESS = "GET_USER_PCT_UNLOCK_HISTORY_SUCCESS";